import { createSlice } from '@reduxjs/toolkit'
import { RootState } from '../store.ts'
import {
  AccountCategory,
  AccountFirmRole,
  AccountGroupRole,
  AccountInternalRole,
  AccountStatus,
  AccountType,
  StatisticsAccountType,
} from '../../enums/management-input.enum.ts'
import { getCurrentQuarterRange } from '../../utils/time.ts'

interface ManagementInputState {
  // Ticker management
  category: string
  expiredTicker: boolean
  dateRange: [string | null, string | null]

  // Account management
  accountType: AccountType
  accountFirm: string
  accountFirmRole: AccountFirmRole
  accountCategory: AccountCategory
  accountGroupRole: AccountGroupRole
  accountInternalRole: AccountInternalRole
  accountStatus: AccountStatus
  accountIsTrial: boolean

  // Statistics
  firm: string
  accountStatisticsTrialType: StatisticsAccountType
}

export const managementInputSlice = createSlice({
  name: 'managementInput',
  initialState: {
    category: '',
    expiredTicker: false,
    dateRange: getCurrentQuarterRange() as [string, string],
    accountType: 'External',
    accountFirm: '',
    accountFirmRole: '',
    accountCategory: '',
    accountGroupRole: '',
    accountInternalRole: 'All',
    accountStatus: 'All',
    accountIsTrial: false,
    firm: '',
    accountStatisticsTrialType: '',
  } as ManagementInputState,
  reducers: {
    setCategory: (state, action) => {
      state.category = action.payload
    },
    setExpiredTicker: (state, action) => {
      state.expiredTicker = action.payload
    },
    setManagementInputDateRange: (state, action) => {
      state.dateRange = [
        action.payload?.[0] ? action.payload[0] : null,
        action.payload?.[1] ? action.payload[1] : null,
      ]
    },
    setAccountType: (state, action) => {
      state.accountType = action.payload
    },
    setAccountFirm: (state, action) => {
      state.accountFirm = action.payload
    },
    setAccountFirmRole: (state, action) => {
      state.accountFirmRole = action.payload
    },
    setAccountCategory: (state, action) => {
      state.accountCategory = action.payload
    },
    setAccountGroupRole: (state, action) => {
      state.accountGroupRole = action.payload
    },
    setAccountInternalRole: (state, action) => {
      state.accountInternalRole = action.payload
    },
    setAccountStatus: (state, action) => {
      state.accountStatus = action.payload
    },
    setAccountIsTrial: (state, action) => {
      state.accountIsTrial = action.payload
    },
    setManagementFirm: (state, action) => {
      state.firm = action.payload
    },
    setAccountStatisticsTrialType: (state, action) => {
      state.accountStatisticsTrialType = action.payload
    },
  },
})

export const selectManagementInput = (state: RootState) =>
  state.managementInput

export const {
  setCategory,
  setExpiredTicker,
  setManagementInputDateRange,
  setAccountType,
  setAccountFirm,
  setAccountFirmRole,
  setAccountCategory,
  setAccountGroupRole,
  setAccountInternalRole,
  setAccountStatus,
  setAccountIsTrial,
  setManagementFirm,
  setAccountStatisticsTrialType,
} = managementInputSlice.actions
